/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import * as actions from '../../actions/index';
import { styles } from './Activation.styles';
import Input from '../Input';
import BackButton from '../BackButton';
import CommonDesign from '../CommonDesign';
import { marketing } from '../../constants';
import activationImage from '../../assets/pictures/activationImage.png';
import { changeActivation, handleChange } from './Activation.services';

function Activation({ classes, history = {}, enabled, message, title, offset, openErrorModal }) {
  const [stateObj, setStateObjRaw] = useState({
    isLoading: false,
    enabled: false,
    message: '',
    title: '',
    offset: null

  });
  const [validationMessage, setValidationMessage] = useState({ message: '', title: '', offset: null });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });


  useEffect(() => {
    setStateObj({ enabled, message, title, offset });
  }, [enabled, message, title, offset]);



  const activationComponent = (
    <div elevation={0} className={`${classes.paper} ${!stateObj.enabled && classes.disabledStyle}`}>
      <>
        <p className={classes.designText}>Titre</p>
        <Input
          margin='dense'
          type='text'
          id='title'
          variant='outlined'
          value={stateObj.title}
          className={classes.inputStyle}
          error={validationMessage.title && validationMessage.title.text === 'is-invalid'}
          placeholder='Ex:Bienvenue chez...'
          onChange={e => (
            setStateObj({ title: e.target.value }),
            handleChange(e, validationMessage, setValidationMessage)
          )}
          onFocus={e => handleChange(e, validationMessage, setValidationMessage)}
          onBlur={e => handleChange(e, validationMessage, setValidationMessage)}
        />

        <p className={classes.designText}>Message</p>
        <Input
          margin='dense'
          multiline
          type='text'
          id='message'
          variant='outlined'
          rows={3}
          value={stateObj.message}
          className={classes.inputStyle}
          placeholder='Ex:Votre restaurant vous souhaite la bienvenue...'
          error={validationMessage.message && validationMessage.message.text === 'is-invalid'}
          onChange={e => (
            setStateObj({ message: e.target.value }),
            handleChange(e, validationMessage, setValidationMessage)
          )}
          onFocus={e => handleChange(e, validationMessage, setValidationMessage)}
          onBlur={e => handleChange(e, validationMessage, setValidationMessage)}
        />

        <p className={classes.designText}>Nombre d'heures après l'installation</p>
        <Input
          margin='dense'
          type='number'
          id='offset'
          variant='outlined'
          value={stateObj.offset}
          onChange={e => (
            setStateObj({ offset: parseInt(e.target.value, 10) }),
            handleChange(e, validationMessage, setValidationMessage)

          )}
          className={classes.inputStyle}
          error={validationMessage.offset && validationMessage.offset.text === 'is-invalid'}
          placeholder='Ex:1,2,3...'
          onFocus={e => handleChange(e, validationMessage, setValidationMessage)}
          onBlur={e => handleChange(e, validationMessage, setValidationMessage)}
          InputProps={{
            endAdornment: <InputAdornment position='end'>heures</InputAdornment>
          }}
        />
      </>
    </div>
  );

  return (
    <div className='p-4'>
      <BackButton
        className='p-0'
        onClick={() => history.goBack()}
        title={marketing.activation.text}
        subtitle={marketing.activation.description}
      />

      <CommonDesign
        child={activationComponent}
        src={activationImage}
        onClick={() =>
          changeActivation(openErrorModal, stateObj, setStateObj, validationMessage)
        }
        isLoading={stateObj.isLoading}
        title={`${stateObj.enabled ? 'Désactiver' : 'Activer'}  mon message de bienvenue`}
        checked={stateObj.enabled}
        onChange={() => setStateObj({ enabled: !stateObj.enabled })}
        disabled={!enabled && !stateObj.enabled}
        isAddition={true}
      />
    </div>
  );
}

function mapStateToProps({ firebaseRealTime }) {
  const { generalConfig = {} } = firebaseRealTime;

  const { activation = {} } = generalConfig;
  const { enabled, message, title, offset } = activation;

  return {
    enabled,
    message,
    title,
    offset
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(Activation)));
